// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { inwardSquaresThree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-inward-squares-three': IconInwardSquaresThree;
    }
}

/**
 * The icon component for the 'inwardSquaresThree' icon
 */
export class IconInwardSquaresThree extends IconSvg {
    public constructor() {
        super(inwardSquaresThree16X16);
    }
}

registerIconSvg('icon-inward-squares-three', IconInwardSquaresThree);
export const iconInwardSquaresThreeTag = 'nimble-icon-inward-squares-three';
